module.exports = __webpack_public_path__ + "img/project17_4.png.f76a8bcc.webp";